export default {"src":"/_next/static/media/reduction-energy-loss.1bf992f1.svg","height":151,"width":151,"blurWidth":0,"blurHeight":0};